module.exports = require('./components/ktoanswer');
